import { useContext, useEffect } from "react";
import { sendClientSideSplitTrackEvent } from "@leafly-com/split-next";
import classnames from "classnames";
import { useSelector } from "react-redux";

import MenuContext from "context/MenuContext";
import { MenuItem } from "custom-types/MenuItem";
import { getUserPrefersMedical } from "redux/selectors/user";
import { getSplitKey } from "utils/split/getSplitKey";

import Carousel from "components/botanic/Carousel";
import MenuCard from "components/Dispensary/MenuCard";

const StaffPicksCarousel: React.FC<{
  cardsPerSlide?: number;
  className?: string;
}> = ({ className, cardsPerSlide = 4 }) => {
  const {
    selectors: { staffPicks, loading },
    dispatch: { getStaffPicks },
  } = useContext(MenuContext);

  const userPrefersMedical = useSelector(getUserPrefersMedical);

  useEffect(() => {
    getStaffPicks();
  }, [userPrefersMedical]);

  if (loading || !staffPicks?.length) {
    return null;
  }

  return (
    <div data-testid="staff-picks-carousel" className={classnames(className)}>
      <Carousel
        cardsPerSlide={cardsPerSlide}
        title={
          <h2
            className="heading--m font-extrabold"
            data-testid="section-header"
          >
            Staff favorites
          </h2>
        }
      >
        {staffPicks.map((item: MenuItem) => (
          <MenuCard
            key={item.id}
            menuItem={item}
            onAddToBagClick={() => {
              sendClientSideSplitTrackEvent(
                "webDispensaryMenuItem_addToBagClick_frontend",
                getSplitKey()
              );
            }}
          />
        ))}
      </Carousel>
    </div>
  );
};

export default StaffPicksCarousel;
